import { toPoints} from '@/shared/helpers'
export const TABLE_COLUMNS = [
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Count",
    accessor: "count",
  },
  {
    Header: "Unique Count",
    accessor: "unique_count",
  },
];
